import { useContext, useEffect, useState } from 'react';
import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import NotifyForm from './NotifyForm/NotifyForm';
import NotifySuccess from './NotifySuccess/NotifySuccess';

import LeftArrow from '../../assets/BlueLeftArrow.svg';
import RightArrow from '../../assets/BlueRightArrow.svg';

import './Notify.scss';
import { getPackages } from '../../api/api';

interface Props {
    rtl: boolean;
    center: any;
}

function Notify({ rtl, center }: Props) {
    const { t } = useTranslation();
    const [success, setSuccess] = useState(false);
    const [packages, setPackages] = useState([]);
    const { dispatch }: any = useContext(GlobalContext);

    useEffect(() => {
        let cancel = true;
        dispatch({ type: 'SET_LOADER', payload: true });

        getPackages()
        .then((res: any) => {
            if (!cancel) return;
            if (res.data.status.statusCode === "MBE_000") {
                dispatch({ type: 'SET_LOADER', payload: false });
                setPackages(res.data.data)
            }
        }).catch(err => {
            Error(err.message);
            dispatch({ type: 'SET_LOADER', payload: false })
        })
    return () => {
        cancel = false;
    }
    }, [dispatch]);

    const handleBackClick = () => {
        dispatch({ type: 'SET_NOTIFY_ME', payload: false });
    }

    const floatDirection = rtl ? 'Notify-right' : ''

    return (
        <div className={`container Notify__container ${floatDirection}`}>
            <div className='row'>
                {!success ? (
                    <div className='Notify'>
                        <div className='Notify__backButton' onClick={handleBackClick}>
                            <img src={rtl ? RightArrow : LeftArrow} alt="" />
                            <Typography rtl={rtl}>{t('back_title')}</Typography>
                        </div>

                        <div className='Notify__heading'>
                            <Typography rtl={rtl} className='title'>{t('Notify_me')}</Typography>
                            <Typography rtl={rtl} className='subTitle'>{t('Notify_me_subtitle')}</Typography>
                        </div>

                        <NotifyForm setSuccess={setSuccess} packages={packages} rtl={rtl} center={center} />
                    </div>
                ) : (
                    <NotifySuccess setSuccess={setSuccess} rtl={rtl} />
                )}
            </div>
        </div>
    )
}

export default Notify